module.exports = __webpack_public_path__ + "static/media/room-space.89296dff.png";